import {RootModel} from "./index";
import {createModel} from "@rematch/core";
import {getAllDictTypes, getAllDicts} from "../apis/sysDict";

type DictState = any;

const initState: DictState = {}

export const dict = createModel<RootModel>()({
    state: initState,
    reducers: {
        setDict: (state: DictState, payload?: any) => ({...state, ...(payload ?? {})})
    },
    effects: (dispatch) => ({

        async getAllDict() {
            const [typeResponse, dictResponse] = await Promise.all([
                getAllDictTypes(),
                getAllDicts()
            ]);
            const types = typeResponse.data.data ?? [];
            const dict = dictResponse.data.data ?? [];
            const toDictMap = (items: any[]) => types.map((t:any)=>{
                const {id,code} = t;
                const dictResult = items.filter((d:any)=>d.typeId==id).map((d:any)=>({[d.value]:d.name})).reduce((d1:any,d2:any)=>({...d1,...d2}),{});
                return {[code]:dictResult};
            }).reduce((t1:any,t2:any)=>({...t1,...t2}),{});
            const disabledOptions = types.map((t:any) => ({
                [t.code]: dict.filter((d:any) => d.typeId == t.id && !d.status)
                    .map((d:any) => ({[d.value]: true}))
                    .reduce((d1:any, d2:any) => ({...d1, ...d2}), {})
            })).reduce((t1:any, t2:any) => ({...t1, ...t2}), {});
            dispatch.dict.setDict({
                ...toDictMap(dict),
                _disabledOptions: disabledOptions
            });
        }
    })
});
